<template>
  <div class="main band-card">
    <div class="nav">
      <Nav :title="'就诊卡详情'"></Nav>
    </div>
    <van-form validate-first>
      <van-field
        readonly
        disabled
        size="large"
        label="证件类型"
        :placeholder="form.certificateNoType"
      />
      <van-field
        v-model="form.certificateNo"
        disabled
        type="textarea"
        rows="1"
        autosize
        size="large"
        label="证件号码"
        :placeholder="form.certificateNo"
      />
      <van-field
        v-model="form.clientName"
        disabled
        size="large"
        label="姓名"
        :placeholder="form.clientName"
      />
      <van-field label="性别" disabled size="large">
        <template #input>
          <van-radio-group
            disabled
            v-model="form.genderId"
            direction="horizontal"
            size="large"
          >
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        disabled
        size="large"
        label="出生日期"
        v-model="form['birthDay']"
        placeholder="选择出生日期"
      />
       <van-field
        v-model="form['nationName']"
        size="large"
        label="民族"
        disabled
        :placeholder="form.nationName"
      />
      <van-field
        v-model="form['nationalityName']"
        size="large"
        label="国籍"
        disabled
        :placeholder="form.nationalityName"
      />
      <van-field
        v-model="this.addre"
        size="large"
        label="地址"
        disabled
        :placeholder="this.addre"
      />
      <van-field
        v-model="form['address']"
        size="large"
        label="现住址" 
        disabled
        :placeholder="form.address"
      />
      <van-field
        readonly
        disabled
        size="large"
        label="医保类型"
        placeholder="现金"
      />

      <van-field
        v-model="form.phoneNumber"
        disabled
        size="large"
        label="手机号码"
        :placeholder="form.phoneNumber"
      />
      <van-field
        readonly
        disabled
        size="large"
        label="职业类型"
        value=""
        :placeholder="form.professionName"
      />
    </van-form>
  </div>
</template>

<script>
import setOptions from "./../../mixins/setOption";
import Nav from "./../../components/nav.vue";
export default {
  mixins: [setOptions],
  data() {
    return {
      ishaveID: true,
      IdCardList: [],
      professionOBJ: [],
      addre: "",
      nationOBJ: [
        { value: 1, name: "汉族" },
        { value: 2, name: "蒙古族" },
        { value: 3, name: "回族" },
        { value: 4, name: "藏族" },
        { value: 5, name: "维吾尔族" },
        { value: 6, name: "苗族" },
        { value: 7, name: "彝族" },
        { value: 8, name: "壮族" },
        { value: 9, name: "布依族" },
        { value: 10, name: "朝鲜族" },
        { value: 11, name: "满族" },
        { value: 12, name: "侗族" },
        { value: 13, name: "瑶族" },
        { value: 14, name: "白族" },
        { value: 15, name: "土家族" },
        { value: 16, name: "哈尼族" },
        { value: 17, name: "哈萨克族" },
        { value: 18, name: "傣族" },
        { value: 19, name: "黎族" },
        { value: 20, name: "傈僳族" },
        { value: 21, name: "佤族" },
        { value: 22, name: "畲族" },
        { value: 23, name: "高山族" },
        { value: 24, name: "拉祜族" },
        { value: 25, name: "水族" },
        { value: 26, name: "东乡族" },
        { value: 27, name: "纳西族" },
        { value: 28, name: "景颇族" },
        { value: 29, name: "柯尔克孜族" },
        { value: 30, name: "土族" },
        { value: 31, name: "达斡尔族" },
        { value: 32, name: "仫佬族" },
        { value: 33, name: "羌族" },
        { value: 34, name: "布朗族" },
        { value: 35, name: "撒拉族" },
        { value: 36, name: "毛难族" },
        { value: 37, name: "仡佬族" },
        { value: 38, name: "锡伯族" },
        { value: 39, name: "阿昌族" },
        { value: 40, name: "普米族" },
        { value: 41, name: "塔吉克族" },
        { value: 42, name: "怒族" },
        { value: 43, name: "乌孜别克族" },
        { value: 44, name: "俄罗斯族" },
        { value: 45, name: "鄂温克族" },
        { value: 46, name: "崩龙族" },
        { value: 47, name: "保安族" },
        { value: 48, name: "裕固族" },
        { value: 49, name: "京族" },
        { value: 50, name: "塔塔尔族" },
        { value: 51, name: "独龙族" },
        { value: 52, name: "鄂伦春族" },
        { value: 53, name: "赫哲族" },
        { value: 54, name: "门巴族" },
        { value: 55, name: "珞巴族" },
        { value: 56, name: "基诺族" },
      ],
      form: {
        clientName: "",
        genderId: "",
        certificateNoType: "",
        certificateNo: "",
        birthDay: "",
        address: "",
        pactId: "1",
        phoneNumber: "",
        profession: "51",
        professionName: "",
        nationalityName: "",
        addProvinceName: "",
        addCityName: "",
        addCountyName: "",
        nationName: "",
        
      },
     
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.getcoulms();
  },
  methods: {
    //nav返回
    onClickLeft() {
      this.$router.go(-1);
    },
    getBindFormData() {
      if (this.$route.query.userdata) {
        let userdata = this.$route.query.userdata;
        this.form.address = userdata.address;
        this.form.phoneNumber = userdata.phoneNumber;
        this.form.certificateNo = userdata.certificateNo;
        this.form.clientName = userdata.clientName;
        this.form.genderId = this.getgenderIDbyIdCard(userdata.certificateNo);
        this.form.birthDay = this.getBirthdayFromIdCard(userdata.certificateNo);
        this.form.nationalityName = userdata.nationalityName
        this.form.addProvinceName = userdata.addProvinceName
        this.form.addCityName = userdata.addCityName
        this.form.addCountyName = userdata.addCountyName
        
        if(!userdata.addProvinceName || !userdata.addCityName ||!userdata.addCountyName){
          this.addre=""
        }else{
          this.addre = this.form.addProvinceName+" "+this.form.addCityName+" "+this.form.addCountyName
        }
        console.log(userdata)
        this.form.professionName = this.findValueByname(
          userdata.professionId,
          this.professionOBJ
        );
        this.form.certificateNoType = this.findValueByname(
          userdata.certificateType.toString(),
          this.IdCardList
        );
        // console.log(userdata.nationId)
        let nationarrs =this.nationOBJ.filter((value,index)=>{
          return value.value == userdata.nationId
          
        });
        nationarrs.forEach((item,index)=>{
          this.form.nationName = item.name
          // console.log(this.form.nationName)
        })
          
      }
      
    },
    findValueByname(value, info) {
      // for (let temp in info) {
      //   if (info[temp].value == value) {
      //     return info[temp].name;
      //   }
      // }
       return  info.find(info=>info.value===value).name
       
    },
    getgenderIDbyIdCard(idcard) {
      if (parseInt(idcard.substr(16, 1)) % 2 == 1) {
        //男
        return "1";
      } else {
        //女
        return "2";
      }
    },
    //通过身份证获取生日
    getBirthdayFromIdCard(idCard) {
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    },
    //获取选项卡列表
    async getcoulms() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/hospitalconf/index/getObjType";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            // console.log(data);

            //证件类型
            this.IdCardList = data.data.idCardObj;
            // console.log(this.IdCardList[0].name)
            //职业类型
            this.professionOBJ = data.data.professionOBJ;
            // console.log(this.professionOBJ[2].name)
            this.getBindFormData();
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //身份证输入框失去焦点事件

    //通过身份证号获得性别

    //格式化日期
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  margin-bottom: 15px;
  .submit {
    margin: 35px 16px;
  }
}
</style>
<style lang="scss">
.band-card {
  .van-cell {
    font-size: 16px;
  }
  .van-cell.van-cell--large {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .van-field__error-message {
    font-size: 14px;
  }
}
.van-field--disabled .van-field__label {
  color: #646566;
}
</style>